import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase/config';
import { EntityFormationWizard } from '../components/intake/EntityFormationWizard';
import Navigation from '../components/Navigation';

/**
 * Page component for Entity Formation Intake form
 * Requires authentication - redirects to sign-in if not authenticated
 * Supports loading a specific draft via ?draftId= query parameter
 */
const EntityFormationIntakePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract draftId from query params
  const searchParams = new URLSearchParams(location.search);
  const draftId = searchParams.get('draftId') || undefined;

  useEffect(() => {
    if (auth.currentUser === null) {
      navigate('/sign-in', { state: { from: location.pathname + location.search } });
    }
  }, [navigate, location]);

  // If not authenticated, don't render anything (will redirect)
  if (auth.currentUser === null) {
    return null;
  }

  return (
    <div>
      <Navigation />
      <EntityFormationWizard specificDraftId={draftId} />
    </div>
  );
};

export default EntityFormationIntakePage;

